import clsx from "clsx";


import CalloutSection from "../components/callout-section";
import VideoSection from "../components/video-section";
import NewsContinued from "../components/news-continued";
import MeetOurClients from "../components/meet-our-clients";
import SocialMembership from "../components/social-membership";
import BrowseSolutions from "../components/browse-solutions";
import NewsHomeColumn from "../components/news-home-column";
import SeoMeta from "../components/seo-meta";

import styles from "./index.module.scss";
import config from "../config";

export default function Home({
  articles,
  solutions,
  video,
  memberCalloutSection,
  locationCalloutSection,
  meetOurClientsData,
  seo
}) {
  const posts = articles.slice(0, 2);

  const postsContinued = [...articles.slice(2)];

  return (
    <>
      <SeoMeta {...seo} />

      <div className="container">
        <div className={styles.WorkspacesBanner}>
          <h1 className={styles.WorkspacesTitle}>Workspaces, Etc</h1>
          {/* <Image
            src="/images/workspaces-etc.png"
            alt="East Room Workspaces, Etc."
            layout="responsive"
            width={714}
            height={97}
            priority
          /> */}
        </div>
      </div>

      <div className={clsx("container", styles.Columns)}>
        <div className={styles.Column}>
          <BrowseSolutions solutions={solutions} />
        </div>

        <div className={styles.Column}>
          <NewsHomeColumn posts={posts} />
        </div>
      </div>

      <NewsContinued posts={postsContinued} />

      <VideoSection title="" description="" video={video} />

      <div className={styles.MeetOurClientsWrapper}>
        <MeetOurClients showLogos={false} data={meetOurClientsData} />
      </div>

      {memberCalloutSection && (
        <SocialMembership
          title={memberCalloutSection.title}
          subtitle={memberCalloutSection.subtitle}
          description={memberCalloutSection.description}
          url={memberCalloutSection.callToActionUrl}
          image={`${memberCalloutSection.image.url}?w=1200&fm=webp&q=80`}
          buttonText={memberCalloutSection.callToActionText}
        />
      )}

      {locationCalloutSection && (
        <div className={styles.PreleasingWrapper}>
          <CalloutSection {...locationCalloutSection} />
        </div>
      )}
    </>
  );
}

export async function getStaticProps() {
  try {
    const [
      { getHomePageBlogArticles },
      { getSolutions },
      { getAsset },
      { getCalloutSection },
      { getMeetOurClients },
      { getSEOPageProps }
    ] = await Promise.all([
      import("../lib/blog-articles"),
      import("../lib/solutions"),
      import("../lib/asset"),
      import("../lib/callout-section"),
      import("../lib/meet-our-clients"),
      import("../lib/seo")
    ]);

    const [
      articles,
      solutions,
      video,
      memberCalloutSection,
      locationCalloutSection,
      meetOurClientsData,
      seo
    ] = await Promise.all([
      getHomePageBlogArticles(),
      getSolutions(),
      getAsset("BmezNjCAwnQccXF4E9i5W"),
      getCalloutSection("membership"),
      getCalloutSection("homepage"),
      getMeetOurClients(),
      getSEOPageProps({ resolvedUrl: "/" })
    ]);

    return {
      props: {
        articles,
        solutions,
        video,
        memberCalloutSection,
        locationCalloutSection,
        meetOurClientsData,
        seo
      },
      revalidate: config.ISR_TIMING
    };
  } catch (e) {
    console.log("ERROR", e.message);
    console.log(e.message);
    // Fail the build rather than ship an empty page. During ISR revalidation
    // Next catches this and keeps serving the last good render.
    throw e;
  }
}
